var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { EventEmitter } from '@angular/core';
import { MenuLink } from '../menu-link.model';
import { LocaleAwareBaseComponent } from './../../../../seo/locale-aware-base.component';
var MenuItemBaseComponent = /** @class */ (function (_super) {
    __extends(MenuItemBaseComponent, _super);
    function MenuItemBaseComponent(window) {
        var _this = _super.call(this) || this;
        _this.window = window;
        _this.children = [];
        _this.toggleMobileMenu = new EventEmitter();
        _this.toggle = true;
        _this.isOpen = false;
        return _this;
    }
    MenuItemBaseComponent.prototype.toggleMenu = function () {
        var _this = this;
        if (this.window) {
            setTimeout(function () {
                if (_this.window.innerWidth < 960) {
                    _this.toggle = !_this.toggle;
                    _this.toggleMobileMenu.next(_this.toggle);
                }
            }, 200);
        }
    };
    MenuItemBaseComponent.prototype.isItemLinkActive = function (item, children) {
        var _this = this;
        if (item.link === this.currentRoute) {
            return true;
        }
        else if (this.currentRoute.includes(item.link) && item.link !== '/') {
            return true;
        }
        if (children.length > 0) {
            if (children.find(function (child) { return _this.currentRoute.includes(child.link); })) {
                return true;
            }
        }
        return false;
    };
    return MenuItemBaseComponent;
}(LocaleAwareBaseComponent));
export { MenuItemBaseComponent };



// WEBPACK FOOTER //
// ./src/app/common-theme/base-components/shared/menu/menu-item-base/menu-item-base.component.ts.pre-build-optimizer.js